import api from './api';

export interface FlightFile {
  id: string;
  filename: string;
  s3_key: string;
  s3_url: string;
  content_type: string;
  file_size: number;
  presigned_url?: string;
}

class FlightFileService {
  async getFlightFiles(itineraryId: number, flightId: number): Promise<FlightFile[]> {
    const response = await api.get(`/converted-itineraries/${itineraryId}/flights/${flightId}/files`);
    return response.data.files || [];
  }

  async uploadFlightFile(
    itineraryId: number,
    flightId: number,
    file: File
  ): Promise<FlightFile> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(
      `/converted-itineraries/${itineraryId}/flights/${flightId}/files`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data.file;
  }

  async deleteFlightFile(itineraryId: number, flightId: number, fileId: string): Promise<void> {
    await api.delete(`/converted-itineraries/${itineraryId}/flights/${flightId}/files/${fileId}`);
  }

  async downloadFlightFile(itineraryId: number, flightId: number, fileId: string): Promise<Blob> {
    const response = await api.get(
      `/converted-itineraries/${itineraryId}/flights/${flightId}/files/${fileId}/download`,
      {
        responseType: 'blob',
      }
    );
    return response.data;
  }

  getFileUrl(itineraryId: number, flightId: number, fileId: string): string {
    return `/converted-itineraries/${itineraryId}/flights/${flightId}/files/${fileId}/download`;
  }
}

export const flightFileService = new FlightFileService();
